import lazyScripts from "../../services/lazy-scripts";
import extend from "../../services/extend";
/**
 *
 * @example For using petite objects
 * v-preview="model.videoPreviewUrl" data-ajax
 * @returns {boolean}
 */
export default (vue) => extend(vue, (vue) => {

     if (!vue.el.dataset.source.length) {
         return false;
     }

     let handler = ('ontouchstart' in document.documentElement ? "touchmove" : "mouseenter");

     vue.el.addEventListener(handler, (e) => {
         vue.el.parentNode.dataset.hover = "true";
         if (vue.el.parentNode.querySelector('video') === null) {
             deletePreview();
             createPreview();
         }
     }, {passive: true});

     if (handler === 'mouseenter') {
         vue.el.addEventListener('mouseleave', () => {
             delete vue.el.parentNode.dataset.hover;
             deletePreview();
         }, {passive: true});
     }


     let createPreview = () => {
         const video = document.createElement('video');

         if (vue.el.dataset.source.includes(".m3u8")) {
             lazyScripts.loadHls().then(() => {
                 if (!Hls.isSupported()) {
                     video.setAttribute('src', vue.el.dataset.source);
                     return;
                 }

                 const hlsInstance = new Hls({
                     maxMaxBufferLength: 15,
                 });
                 setTimeout(() => {
                     hlsInstance.loadSource(vue.el.dataset.source);
                     hlsInstance.attachMedia(video);
                 }, 50);
             });
         } else {
             video.setAttribute('src', vue.el.dataset.source);
         }

         video.setAttribute('playsinline', "true");
         video.setAttribute('webkit-playsinline', "true");
         video.setAttribute('autoplay', "autoplay");
         video.setAttribute('muted', "muted");
         video.setAttribute('loop', "loop");

         video.addEventListener('loadeddata', function () {
             video.dataset.loaded = "true";
             video.volume = 0.0;
             video.muted = true;
         }, {passive: true});

         vue.set('preview', video);

         vue.el.parentNode.prepend(video);

     };

    let deletePreview = () => {
        if ( vue.get('preview')) {
            vue.get('preview').remove();
            vue.set('preview', false);
        }
    };


});